export default {
  namespaced  : true,

  state       : {
    selectedStoryId   : null,
    selectedChapterId : null,
    selectedPageId    : null,

    isOpenStoryModal          : false,
    isOpenStoryModalLoading   : false,
    isOpenStoryModalPage      : false,
    isOpenStoryModalNavigator : false,
    isOpenStoryTitle          : false,

    couldScroll : {
      up    : false,
      down  : false,
    },

    paginate    : {
      prev    : false,
      next    : false,

      pageId  : {
        prev  : null,
        next  : null,
      },

      index   : null,
      max     : null,
    },
  },

  mutations   : {
    setCouldScroll(state, parameters){
      if(typeof parameters.up !== 'undefined'){
        state.couldScroll.up = parameters.up;
      }

      if(typeof parameters.down !== 'undefined'){
        state.couldScroll.down = parameters.down;
      }
    },

    setStoryId(state, value){
      state.selectedStoryId = value;
    },

    setChapterId(state, value){
      state.selectedChapterId = value;
    },

    setPageId(state, value){
      state.selectedPageId = value;
    },

    setIsOpenStoryModal(state, value){
      state.isOpenStoryModal = value;
    },

    setIsOpenStoryModalLoading(state, value){
      state.isOpenStoryModalLoading = value;
    },

    setIsOpenStoryModalPage(state, value){
      state.isOpenStoryModalPage = value;
    },

    setIsOpenStoryModalNavigator(state, value){
      state.isOpenStoryModalNavigator = value;
    },

    setIsOpenStoryTitle(state, value){
      state.isOpenStoryTitle = value;
    },

    setPaginate(state, parameters){
      if(typeof parameters.prev !== 'undefined'){
        state.paginate.prev = parameters.prev;
      }

      if(typeof parameters.next !== 'undefined'){
        state.paginate.next = parameters.next;
      }

      if(typeof parameters.prevPageId !== 'undefined'){
        state.paginate.pageId.prev = parameters.prevPageId;
      }

      if(typeof parameters.nextPageId !== 'undefined'){
        state.paginate.pageId.next = parameters.nextPageId;
      }

      if(typeof parameters.index !== 'undefined'){
        state.paginate.index = parameters.index;
      }
      
      if(typeof parameters.max !== 'undefined'){
        state.paginate.max   = parameters.max;
      }
    }
  },

  actions     : {
    updateCouldScroll(context, payload){
      context.commit('setCouldScroll', payload.parameters);
    },
    
    updatePaginate(context, payload){
      context.commit('setPaginate', payload.parameters);
    },
    
    updateSelectedStory(context, payload){
      if(typeof payload.storyId !== 'undefined'){
        context.commit('setStoryId', payload.storyId);
      }

      if(typeof payload.chapterId !== 'undefined'){
        context.commit('setChapterId', payload.chapterId);
      }

      if(typeof payload.pageId !== 'undefined'){
        context.commit('setPageId', payload.pageId);
      }
    },

    updateIsOpenStoryModal(context, payload){
      if(typeof payload.initialize === 'undefined') payload.initialize = false;
      
      if(payload.initialize === true){
        context.commit('setIsOpenStoryModal',           false);
        context.commit('setIsOpenStoryModalLoading',    false);
        context.commit('setIsOpenStoryModalPage',       false);
        context.commit('setIsOpenStoryModalNavigator',  false);
        context.commit('setIsOpenStoryTitle',           false);
      }

      context.commit('setIsOpenStoryModal', payload.value);
    },

    updateIsOpenStoryModalLoading(context, payload){
      context.commit('setIsOpenStoryModalLoading', payload.value);
    },

    updateIsOpenStoryModalPage(context, payload){
      context.commit('setIsOpenStoryModalPage', payload.value);
    },

    updateIsOpenStoryModalNavigator(context, payload){
      context.commit('setIsOpenStoryModalNavigator', payload.value);
    },

    updateIsOpenStoryTitle(context, payload){
      context.commit('setIsOpenStoryTitle', payload.value);
    }
  }
}